<template>
  <div class="play-container">
    <top-bar :user="this.user" />
    <Menu :user="this.user" :menuSelected="{ manageRewards: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ manageRewards: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true
      }">
        <div>
          <!-- userul este marketing -->
          <div class="account-title ">
            <h1>
              {{ $t("cmsLang.pendingGamesTitle") }}
              <a @click="addModifyReward(null)" class="button-all button-yellow">
                <img src="@/assets/images/cms-mkt/plus.svg" />
                {{ $t("cmsLang.addRewardLabel") }}
              </a>
              <a @click="showDailyMission()" class="button-all button-yellow">
                {{ $t("cmsLang.dailyLabel") }}
              </a>
            </h1>
            <br />
          </div>

          <div class="d-flex flex-wrap">
            <div v-if="this.pendingRewards === null ||
              this.pendingRewards === undefined
              ">
              <div class="loading">
              </div>
            </div>
            <!-- <div v-else v-for="(offer, index) in submittedRewards" :key="index" class="content-delivery"> -->
            <reward-case v-else v-for="(entry, index) in pendingRewards" :key="index" :reward="entry" :user="user"
              :editable="true" @upload="showUploadVouchersPopup" @edit="addModifyReward" @approve="addModifyReward"
              @delete="addModifyReward" @showdetails="showDetails" />
          </div>
        </div>
        <br />
        <div>
          <!-- userul este marketing -->
          <div class="account-title ">
            <h1>{{ $t("cmsLang.submittedRewardsTitle") }}</h1>
            <br />
          </div>

          <div class="d-flex flex-wrap">
            <div v-if="this.submittedRewards === null ||
              this.submittedRewards === undefined
              ">
              <div class="loading">
                <img src="@/assets/images/cms-mkt/loading.gif" />
              </div>
            </div>
            <!-- <div v-else v-for="(offer, index) in submittedRewards" :key="index" class="content-delivery"> -->
            <reward-case v-else v-for="(entry, index) in submittedRewards" :key="index" :reward="entry" :user="user"
              :editable="false" @showdetails="showDetails" />
          </div>
        </div>
      </div>
    </div>

    <div id="modal_popup_reward_type" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_reward_type', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <br />
        <div class="form-check mr-2 align-baseline d radioButtonCustom">
          <label v-for="(type, index) in rewardTypes" :key="index" @click="addModifyReward(null, type)">
            <input name="rewardType" class="radioButtonCustom" type="radio" :value="type" v-model="selectedRewardType" />
            {{ $t("cmsLang.rewardType_" + type) }}</label>
        </div>
      </div>
    </div>
    <reward-popup :reward="this.selectedReward" :user="this.user" @updatelist="getAllSubmittedRewards"
      @showinfo="showPopupInfo" />

    <reward-details-popup :reward="this.selectedReward" :user="this.user" @edit="addModifyReward"
      @approve="addModifyReward" @delete="addModifyReward" />


    <div id="modal_popup_upload_vouchers" class="modal-popup w-80">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_upload_vouchers', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <div>
          <p v-html='$t("cmsLang.uploadVouchersInfoText")'></p>
          <div class="offer-details-wrapper">
            <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap">
              <div class="container-fluid d-flex flex-column">
                <div class="row d-flex flex-column align-items-baseline w-80 ">
                  <small class="text-break">{{ $t('cmsLang.expiryDateLabel') }}</small>
                  <date-range :noRanges="true" :single="true" :minDateOrder="minDate" :time="expiryDate"
                    @close="expiryDateSelected" />
                </div>
                <br />
                <div class="row d-flex flex-column align-items-baseline w-80 ">
                  <!-- <a @click="downloadModel">{{ $t("cmsLang.downloadLinkText") }}</a> -->
                  <b-form-file v-model="fileUpdateReceived" ref="file" accept=".xls, .xlsx"
                    :placeholder="$t('cmsLang.uploadFileLabel')" @input="uploadUpdateFile"></b-form-file>
                  <br />
                  <br />
                  <a class="button-all button-green" @click="uploadVouchers">
                    {{ $t("cmsLang.uploadButtonLabel") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br />
        <div v-if="this.error">
          <p v-for="(entry, index) in this.error" :key="index">{{ entry.description ? entry.error_code + " : " +
            entry.description : $t('cmsLang.errorMessage_' + entry) }}</p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t('cmsLang.' + this.successMessage) }}</p>
        </div>
      </div>
    </div>
    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />
    <DailyPopup :user="this.user" @showinfo="showPopupInfo" />
  </div>
</template>

<script>
import moment from "moment";
import Menu from "@/components/cms-mkt/Menu.vue";
import TopBar from "@/components/cms-mkt/TopBar.vue";
import Cookies from "js-cookie";
import httpServiceCustomer from "@/http/http-play.js";
import DateRange from "@/components/DateRange.vue";
import RewardCase from "@/components/fragments/cms-mkt/RewardCase.vue";
import RewardPopup from "@/components/fragments/cms-mkt/NewRewardPopup.vue";
import { BFormFile } from "bootstrap-vue";
import RewardDetailsPopup from "@/components/fragments/cms-mkt/RewardDetailsPopup.vue";
import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";
import DailyPopup from "@/components/fragments/cms-mkt/DailyMissionPopup.vue";
import { saveAs } from "file-saver";

// import ModalLoading from "@/components/fragments/cms-mkt/ModalLoading.vue";

export default {
  name: "manageRewards",

  components: {
    // ModalLoading,
    "b-form-file": BFormFile,
    RewardPopup,
    RewardDetailsPopup,
    TopBar,
    RewardCase,
    Menu,
    DateRange,
    ResetPassword,
    DailyPopup
  },
  data() {
    return {
      user: null,
      rewardTypes: ["general", "unique"],
      filter: {
        type: "OFFER",
        person: null
      },
      selectedRewardType: "",
      sortBy: ["NEW", "OLD"],
      sortBySelected: "NEW",
      sortField: "r.rewid",
      sortDirection: "desc",
      submittedRewards: null,
      pendingRewards: null,
      error: null,
      perPage: 10000,
      deleteSuccess: false,
      selectedReward: null,
      selectedRewards: [],
      successMessage: "",
      isLoading: false,
      action: "",
      fileUpdateReceived: null,
      uploadFileContent: null,
      expiryDate: [moment()],
      minDate: moment().toDate(),
    };
  },
  methods: {
    showUploadVouchersPopup(reward) {
      this.showModalPopup("modal_popup_upload_vouchers", true);
      this.expiryDate = [moment()],
        this.selectedReward = reward;
      this.fileUpdateReceived = null,
        this.uploadFileContent = null;
    },
    addModifyReward(reward, label) {
      this.action = "edit";
      this.error = null;
      this.showModalPopup("modal_popup_reward_details", false);
      this.selectedReward = null;
      if (!reward) {
        // if (!label) {
        //   this.showModalPopup("modal_popup_reward_type", true);
        //   return;
        // } else {

        this.selectedRewardType = "unique";
        this.selectedReward = {
          id: 0,
          type: this.selectedRewardType
        };
        // this.showModalPopup("modal_popup_reward_type", false);
        this.showModalPopup("modal_popup_reward", true);
        // }
      } else {
        this.getRewardDetails(reward.id);
      }
    },
    showDailyMission() {
      this.error = null;
      this.showModalPopup("modal_popup_daily", true);
    },
    showDetails(reward) {
      this.action = "details";
      this.getRewardDetails(reward.id);
    },
    getAllSubmittedRewards() {
      this.getSubmittedRewards(false);
      this.getSubmittedRewards(true);
    },
    showPopupInfo(successMessage, error) {
      this.successMessage = successMessage;
      this.error = error;
      this.showModalPopup("modal_popup_daily", false);
      this.showModalPopup("modal_popup_reward", false);
      this.showModalPopup("modal_popup_loading_cms", false);
      this.showModalPopup("modal_popup_info", true);
    },
    getSubmittedRewards(pending) {
      this.selectedRewards = [];
      this.submittedRewards = null;
      var offersData = "?";
      if (pending) {
        // offersData += "&status=NEW";
        offersData += "&status=N,I";
      } else {
        offersData += "&status=A,E";
      }
      offersData +=
        "&per_page=" + this.perPage + "&page=1" + "&sort=" + this.sortDirection;
      if (this.sortDirection === "desc") {
        offersData += "&desc=" + this.sortField;
      } else {
        offersData += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchRewards(offersData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch(error => {
          this.error = {
            code: error.response.data,
            description: error.response.data
          };
        })
        .then(response => {
          if (response.status == 200) {
            if (pending) {
              this.pendingRewards = response.data;
            } else {
              this.submittedRewards = response.data;
            }
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.error = {
              code: response.data,
              description: response.data
            };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = { description: response.description };
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
          }
        });
    },
    sortByChanged(event) {
      this.sortBySelected = event.target.value;
      switch (this.sortBySelected) {
        case "NEW":
          this.sortField = "valstdate";
          this.sortDirection = "desc";
          break;
        case "OLD":
          this.sortField = "valstdate";
          this.sortDirection = "asc";
          break;
        default:
          this.sortField = "valstdate";
          this.sortDirection = "desc";
      }
      this.getSubmittedRewards(false);
    },
    selectFilterType(entry) {
      this.filter.type = entry;
      this.getSubmittedRewards();
    },
    getRewardDetails(rewardId) {
      this.showModalPopup("modal_popup_loading_cms", true);
      this.selectedReward = {};

      httpServiceCustomer.customerService
        .getRewardDetails(rewardId, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .then(response => {
          if (response.status == 200) {
            this.selectedReward = response.data;
            this.showModalPopup("modal_popup_loading_cms", false);
            switch (this.action) {
              case "edit":
                this.showModalPopup("modal_popup_reward", true);
                break;
              case "details":
                this.showModalPopup("modal_popup_reward_details", true);
                break;
            }
          } else {
            this.error = {
              code: response.data.code
            };
          }
        })
        .catch(error => {
          this.error = { code: error.response.code };
          this.showModalPopup("modal_popup_loading_cms", false);
        });
    },
    uploadUpdateFile() {
      var reader = new FileReader();
      reader.onload = e => {
        if (!e) {
          this.uploadFileContent = btoa(reader.content);
        } else {
          this.uploadFileContent = btoa(e.target.result);
        }
      };
      //For Browsers other than IE.
      if (reader.readAsBinaryString) {
        reader.readAsBinaryString(this.fileUpdateReceived);
      } else {
        alert("This browser does not support HTML5.");
      }

      if (!this.fileUpdateReceived) {
        return;
      }
      // */
    },
    uploadVouchers() {
      this.error = null;
      if (!this.uploadFileContent) {
        this.error = { description: "", code: "VOUCHERS.FILE.EMPTY" };
        this.showModalPopup('modal_popup_info', true)
        return;
      }
      this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceCustomer.customerService
        .addVouchersForReward(
          this.selectedReward,
          {
            expire_date: moment(this.expiryDate[0]).format('DD-MM-YYYY'),
            content: this.uploadFileContent
          },
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.successMessage = "rewardVouchersAddSuccess";

          } else {
            this.error = response.data;
          }
          this.showModalPopup("modal_popup_upload_vouchers", false);

          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data;
          } else {
            this.error = ["500"];
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    downloadModel() {

      httpServiceCustomer.customerService
        .getOrderTemplateModelFile(
          Cookies.get("token")
        )
        .then(function (response) {
          return response;
        })
        .catch(() => {
          this.showModalPopup("modal_popup_loading_cms", false);
        })
        .then((response) => {
          if (response.status == 200) {
            var blob = new Blob(
              [utils.base64ToArrayBuffer(response.data.content)],
              {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
              }
            );
            saveAs(blob, response.data.name);
          } else if (response.status == 400 || response.status == 403) {
          }
        });
    },
    expiryDateSelected(value) {
      this.expiryDate = value;
    },

  },
  mounted() {
    this.getAllSubmittedRewards();
  },
  created() {
    this.user = this.getUser();
  }
};
</script>

<style scoped src="@/assets/styles/mkt-cms.css" />
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style src="@/assets/styles/multiselect.css" />

<style scoped>
.right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.left {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.left small {
  padding-right: 10px;
}

.left .status_11 {
  color: #ff0000;
}

.left .status_10 {
  color: #7ea800;
}

.left .status_12 {
  color: #ff0000;
}

.left .status_13 {
  color: #3c4645;
}

.content-delivery {
  flex-direction: column;
  margin-bottom: 20px;
}

.content-delivery .personimg {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 20px;
}

.offer_header {
  width: 100%;
  border-bottom: 1px solid #dcdee3;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.offer_details {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.offer_details .image {
  max-width: 80px;
  max-height: 80px;
  margin: 10px;
  padding: 30px;
}

.offer_details .imageDiv {
  /* height: 128px;
  width: 128px !important;
  margin: 10px; */
  border-radius: 100%;
  border: 1px solid #dcdee3;
  margin: 10px;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-red {
  border: 1px solid #ff0000;
  border-radius: 100px !important;
}

.multiselect {
  width: 50% !important;
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
}

.margin-y-10 {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
